export const REPORT_VALUES = Object.freeze({
  countSimsUsed: "countSimsUsed-Admin",
  simsFeedback: "simsFeedback-Admin",
  professionalStandardsMonthly:
    "monthlySnapshotProfessionalStandardSummaryReport",
  caepQuadrimestral: "monthlySnapshotCaepSimulationSummaryReport",
  aaqepQuadrimestral: "quadrimestralSnapshotAaqepSimulationSummaryReport",
  nelpPselQuadrimestral: "quadrimestralSnapshotNelpPselStandardSummaryReport",
  rawDataVersionOfSimSummary: "rawDataVersionOfSimSummary",
});

export function reportHref(reportValue, { days } = {}) {
  const params = new URLSearchParams({ report: reportValue });
  if (days != null && days !== "") {
    params.set("days", String(days));
  }
  return `/reports?${params.toString()}`;
}

export function isExternalHref(href, externalFlag = false) {
  return Boolean(externalFlag || /^https?:\/\//i.test(href || ""));
}
